import React, { useEffect, useRef, useState } from 'react'
import { useContext } from 'react';
import { JournalContext } from 'src/consumer/context/JournalContext';
import { TileJournalCardsContainer, TileJournalCategory, TileJournalDetailsContainer, TileJournalItemBackgroundImage, TileJournalItemContainer, TileJournalTitle, TileStyledLine, TileStyledSeparatorJournal } from './JournalCardsStyle';
import { defaultBgImgId } from 'src/consumer/constants';
import { mediaURL } from 'src/consumer/services';
import { getCategoryListMap } from 'src/consumer/helpers/courseCardHelper';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle';


export const renderJournalCards = (props, categoryMap, setJournalData) => {

    const { cardsData, tilePolicyId } = props;
    const category = categoryMap?.get("myJournal")
    let journalsData = [];

    cardsData?.map((item) => {
        journalsData.push(item?.journal)
    })

    return journalsData?.map((journalItem, index) => {

        let imgId;
        let imgUrl;

        if (journalItem?.verticalImage) {
            imgId = journalItem?.verticalImage;
        } else if (journalItem?.coverImage) {
            imgId = journalItem?.coverImage;
        } else if (journalItem?.coverIcon) {
            imgId = journalItem?.coverIcon;
        } else {
            imgId = defaultBgImgId;
        }
        imgUrl = `${mediaURL}${imgId}`

        return (
            <TileJournalItemContainer key={index} onClick={() => setJournalData({ showJournal: true, callSource: "tilespage", data: { ...journalItem, callSourceId: tilePolicyId, sourceName: "tile" }, pageState: "", subscription: journalItem?.subscription?.id || "" })}>
                <TileJournalItemBackgroundImage src={imgUrl} />
                <TileJournalDetailsContainer hiddenBelow>
                    <TileJournalCategory>
                        {category?.singleTitle || category?.name}
                    </TileJournalCategory>

                    <TileStyledSeparatorJournal />

                    <TileJournalTitle>
                        {journalItem?.title}
                    </TileJournalTitle>

                    <TileStyledLine />
                    <TileStyledLine />
                    <TileStyledLine />

                </TileJournalDetailsContainer>
            </TileJournalItemContainer>
        )
    })
}


export default function NewJournals(props) {

    const { journalData, setJournalData } = useContext(JournalContext);
    const { setupData } = useContext(SetupContext);
    const categoryMap = getCategoryListMap(setupData);

    const { areTileItemsHovered } = props;
    const cardRef = useRef();
    const [leftButtonVisible, setLeftButtonVisible] = useState(false);
    const [rightButtonVisible, setRightButtonVisible] = useState(false);
    const handleScrollLeft = () => {
        if (cardRef.current) {
            const containerWidth = cardRef.current.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft -= scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScrollRight = () => {
        if (cardRef.current) {
            const containerWidth = cardRef.current.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft += scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScroll = (event) => {
        const container = event.target;
        const scrollPosition = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }
    useEffect(() => {
        const container = cardRef.current;
        const scrollPosition = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }, []);

    return (
        <TileJournalCardsContainer ref={cardRef} onScroll={handleScroll}>
            {areTileItemsHovered && leftButtonVisible &&
                <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
            }
            {renderJournalCards(props, categoryMap, setJournalData)}
            {areTileItemsHovered && rightButtonVisible &&
                <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
            }
        </TileJournalCardsContainer>
    )


}
